import * as C from '../constants';
import { marketLabels } from '../../services/labelUtils';

// nba program
export function getCreateNbaProgramPayload(market) {
    return { countryName:  marketLabels[market]};
}
export function getUpdateNbaProgramPayload(
    status = C.LOYALTY_PROGRAM_STATUS_PUBLISHED
) {
    return { status };
}

// nba point source
export function getCreatePointSourcePayload(name, maxPoints, status) {
    return { name, maxPoints, status };
}
export function getUpdatePonintSourcePayload(name, maxPoints, status) {
    return { name, maxPoints, status };
}

// nba tiers
export function getTierListPayload(tierList) {
    let tiers = tierList.map((tier) => {
        const action =
            tier.action !== C.TIER_ACTION_CREATE &&
            tier.action !== C.TIER_ACTION_DELETE
                ? C.TIER_ACTION_UPDATE
                : tier.action;

        return {
            nbaTierId: tier.nbaTierId,
            name: tier.name,
            description: tier.description,
            points: parseInt(tier.points),
            ranking: tier.ranking,
            status: tier.status,
            action: action,
        };
    });
    return { tiers };
}

export function getTierPayload(
    name,
    description,
    points,
    ranking,
    status = 'DRAFT'
) {
    // console.log(ranking);
    return {
        name,
        description,
        points: parseInt(points),
        ranking: parseInt(ranking),
        status,
    };
}

// nba rules
export function getCreateRulePayload(
    description,
    condition,
    action,
    ruleType = 'POINT',
    status = 'DRAFT',
    namespace = 'CONSUMER'
) {
    return {
        description,
        condition,
        action,
        ruleType,
        status,
        namespace,
    };
}
export function getUpdateRulePayload(
    description,
    condition,
    action,
    ruleType = 'POINT',
    status = 'DRAFT'
) {
    return {
        description,
        condition,
        action,
        ruleType,
        status,
    };
}
